import "./plugins/axios";
import { createApp } from "vue";
import App from "./views/main/index.vue";
import AppM from "./views-m/main/index.vue";
import router from "./router";
import store from "./store";
import { isMobile } from "@/libs/tool";
import VConsole from 'vconsole';
// const vConsole = new VConsole();
// import '@/assets/style/common.less'
// import axios from '@/libs/api.request.js'
// import Plugin from './plugins/axios'
// import axios from 'axios'
console.log(isMobile());

createApp(isMobile() ? AppM : App)
  .use(store)
  // .use(Plugin)
  .use(router)
  .mount("#app");
